import { useToken } from "../hooks/useToken";
import { getProjectID, getVisorID } from "../utils/misc";

/**
 * Get the common headers for the API requests.
 * To be used in the API requests.
 * 
 * @returns {Object} The common headers
 */
export function getCommonHeaders(projectId = null) {
    const { token, csrfToken } = useToken();

    let headers = {};

    if (projectId) {
        headers['X-Project-ID'] = projectId;
    }

    let visorID = getVisorID();
    if (visorID) {
        headers['X-Viewer-ID'] = visorID;
    }

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (csrfToken) {
        headers['X-CSRF-TOKEN'] = csrfToken;
    }

    return headers;
}

/**
 * Get the user roles in the app
 * 
 * @param {AbortSignal} [options.signal] - Abort signal to cancel the request
 * @returns {Promise<Object>} The response from the API
 */
export async function getUserRolesInApp({ signal } = {}) {
    const { token } = useToken();
    const projectId = getProjectID();

    return fetch(`/api/user/role${projectId ? `?pid=${projectId}` : ''}`, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            ...(projectId ? { 'X-Project-ID': projectId } : {}),
        },
        signal: signal || null,
    });
}

